import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import App from "./App";
import { SettingsProvider } from "./context/SettingsContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <SettingsProvider>
    <App />
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: { fontFamily: "'DM Sans', sans-serif", fontSize: "14px", padding: "0.5rem 0.5rem" },
        success: { iconTheme: { primary: "#C9A96E", secondary: "#fff" } },
      }}
    />
    </SettingsProvider>
  </BrowserRouter>
);
